import { moduleProviderFactory } from 'core/providers';
import { LookupList } from 'modules/lookup/pages';

(function() {
	moduleProviderFactory.application.register({
		routes: [
			{
				name: 'master.app.main.lookup',
				pattern: '/lookup',
				isPrivate: true,
				children: [
					{
						name: 'master.app.main.lookup.list',
						pattern: '',
						authorization: 'fulfillmentLookupSection.full',
						component: LookupList,
					},
				],
			},
		],
	});
})();



// WEBPACK FOOTER //
// ./src/modules/lookup/config.js